import { createScopedLogger } from "@@common";
import { useEffect, useMemo } from "react";
import { useExpressionEvaluatorContext } from "../../../ExpressionsModule/Hooks/useExpressionEvaluatorContext";
import { ObjectVariableScope } from "../../../ExpressionsModule/Runtime/VariableScopes/ObjectVariableScope";
import { VariableNames } from "../../Constants/VariableNames";
import { IComponent } from "../../Models/IComponent";
import { ComponentService } from "../../Services/ComponentService";

const logger = createScopedLogger("useViewExpressionEvaluatorContext");

/**
 * Creates an expression evaluator context for a component.
 * Primarily designed for Views (ViewModel), but can accept any IComponent for designer preview scenarios.
 */
export default function useViewExpressionEvaluatorContext(component: IComponent | null, input?: Record<string, any>) {
  const context = useExpressionEvaluatorContext();

  const viewContext = useMemo(() => {
    const viewContext = context.CreateChild();
    viewContext.VariableScope.set(VariableNames.View, new ObjectVariableScope({}, viewContext.VariableScope, VariableNames.View));
    logger.debug("Component created viewContext:", component?.Id, viewContext);

    // Only set component service if component exists
    if (component?.Id) {
      const componentService = new ComponentService();
      componentService.setViewComponentId(component.Id);
      viewContext.SetProperty(ComponentService.KEY, componentService);
    }

    return viewContext;
  }, [context, component?.Id]);

  useEffect(() => {
    viewContext.VariableScope.set(VariableNames.Input, input);
    logger.debug("Component set $input:", component?.Id, input);
  }, [viewContext, input, component?.Id]);

  return viewContext;
}
